<template>
  <div>
    <p v-if="message !== null">
      {{ message }}
    </p>

    <contest-player-rewards-table
      v-if="isRewardsVisible"
      :rewards="rewards"
    />

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator          from './LoadingIndicator.vue';
import ContestPlayerRewardsTable from './ContestPlayerRewardsTable.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'ContestPlayerRewards',

  components: {
    LoadingIndicator,
    ContestPlayerRewardsTable,
  },

  props: {
    contestPlayerId: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {Array | null} */
      rewards: null,
    };
  },

  computed: {
    /** @returns {number} */
    contestId() {
      return this.contestPlayerId.contestId;
    },

    /** @returns {number} */
    playerId() {
      return this.contestPlayerId.playerId;
    },

    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const rewards = this.rewards;
      if(rewards !== null && rewards.length === 0) {
        return 'Нет наград.';
      }

      return null;
    },

    /** @returns {boolean} */
    isRewardsVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const rewards = this.rewards;
      return rewards !== null && rewards.length > 0
    }
  },

  created() {
    this.loadRewards();
  },

  methods: {
    loadRewards() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const contestId = this.contestId;
      const playerId = this.playerId;
      const url = `/contest/${contestId}/player/${playerId}/rewards`;

      HTTP.get(url)
      .then(response => {
        this.rewards = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  }
};
</script>
